import { useQuery } from '@tanstack/react-query'
import { getWorkerShiftsForCompany } from 'api/worker'
import { QueryFnData, QueryOptions } from 'queries/types'
import { workerKeys } from './keys'

export function useWorkerShifts<
  TData = QueryFnData<typeof getWorkerShiftsForCompany>
>(
  workerId: number,
  options: QueryOptions<typeof getWorkerShiftsForCompany, TData> = {}
) {
  return useQuery({
    ...options,
    queryKey: workerKeys.shifts(workerId),
    queryFn: () => getWorkerShiftsForCompany(workerId),
  })
}
